function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { HSL2RGB, RGB2HEX, RGB2HSL, RGBA2HEX, string2RGB } from '../util';
export var Color = function () {
  function Color(hsla, options) {
    _classCallCheck(this, Color);

    this.h = 0;
    this.s = 0;
    this.l = 0;
    this.a = 0;
    this.hasAlpha = false;
    this.format = 'rgb';
    Object.assign(this, hsla);
    this.hasAlpha = options.hasAlpha || false;
    this.format = options.format || 'hex';
  }

  _createClass(Color, [{
    key: "getOptions",
    value: function getOptions() {
      return {
        hasAlpha: this.hasAlpha,
        format: this.format
      };
    }
  }, {
    key: "getHue",
    value: function getHue() {
      return this.h;
    }
  }, {
    key: "setHue",
    value: function setHue(h) {
      return Color.fromHSLA(_objectSpread(_objectSpread({}, this.getHSLA()), {}, {
        h: h
      }), this.getOptions());
    }
  }, {
    key: "getAlpha",
    value: function getAlpha() {
      return this.a;
    }
  }, {
    key: "setAlpha",
    value: function setAlpha(a) {
      return Color.fromHSLA(_objectSpread(_objectSpread({}, this.getHSLA()), {}, {
        a: a
      }), this.getOptions());
    }
  }, {
    key: "getSaturation",
    value: function getSaturation() {
      return this.s;
    }
  }, {
    key: "setSaturation",
    value: function setSaturation(s) {
      return Color.fromHSLA(_objectSpread(_objectSpread({}, this.getHSLA()), {}, {
        s: s
      }), this.getOptions());
    }
  }, {
    key: "getLight",
    value: function getLight() {
      return this.l;
    }
  }, {
    key: "setLight",
    value: function setLight(l) {
      return Color.fromHSLA(_objectSpread(_objectSpread({}, this.getHSLA()), {}, {
        l: l
      }), this.getOptions());
    }
  }, {
    key: "setSL",
    value: function setSL(sl) {
      return Color.fromHSLA(_objectSpread(_objectSpread({}, this.getHSLA()), sl), this.getOptions());
    }
  }, {
    key: "getRed",
    value: function getRed() {
      return this.getRGB().r;
    }
  }, {
    key: "setRed",
    value: function setRed(r) {
      return Color.fromRGBA(_objectSpread(_objectSpread({}, this.getRGBA()), {}, {
        r: r
      }), this.getOptions());
    }
  }, {
    key: "getGreen",
    value: function getGreen() {
      return this.getRGB().g;
    }
  }, {
    key: "setGreen",
    value: function setGreen(g) {
      return Color.fromRGBA(_objectSpread(_objectSpread({}, this.getRGBA()), {}, {
        g: g
      }), this.getOptions());
    }
  }, {
    key: "getBlue",
    value: function getBlue() {
      return this.getRGB().b;
    }
  }, {
    key: "setBlue",
    value: function setBlue(b) {
      return Color.fromRGBA(_objectSpread(_objectSpread({}, this.getRGBA()), {}, {
        b: b
      }), this.getOptions());
    }
  }, {
    key: "getRGB",
    value: function getRGB() {
      return HSL2RGB(this.getHSL());
    }
  }, {
    key: "setRGB",
    value: function setRGB(rgb) {
      return Color.fromRGBA(_objectSpread(_objectSpread({}, rgb), {}, {
        a: this.a
      }), this.getOptions());
    }
  }, {
    key: "getRGBA",
    value: function getRGBA() {
      return _objectSpread(_objectSpread({}, this.getRGB()), {}, {
        a: this.a
      });
    }
  }, {
    key: "setRGBA",
    value: function setRGBA(rgba) {
      return Color.fromRGBA(rgba, this.getOptions());
    }
  }, {
    key: "getHSL",
    value: function getHSL() {
      return {
        h: this.h,
        s: this.s,
        l: this.l
      };
    }
  }, {
    key: "setHSL",
    value: function setHSL(hsl) {
      return Color.fromHSLA(_objectSpread(_objectSpread({}, hsl), {}, {
        a: this.a
      }), this.getOptions());
    }
  }, {
    key: "getHSLA",
    value: function getHSLA() {
      return {
        h: this.h,
        s: this.s,
        l: this.l,
        a: this.a
      };
    }
  }, {
    key: "setHSLA",
    value: function setHSLA(hsla) {
      return Color.fromHSLA(hsla, this.getOptions());
    }
  }, {
    key: "trySetHex",
    value: function trySetHex(nv) {
      var rgba = string2RGB(nv);

      if (rgba != null) {
        return Color.fromRGBA(rgba, this.getOptions());
      }

      return null;
    }
  }, {
    key: "toHex",
    value: function toHex() {
      return this.hasAlpha ? this.toHex8() : this.toHex6();
    }
  }, {
    key: "toHex6",
    value: function toHex6() {
      return RGB2HEX(this.getRGB());
    }
  }, {
    key: "toHex8",
    value: function toHex8() {
      return RGBA2HEX(this.getRGBA());
    }
  }, {
    key: "toRGB",
    value: function toRGB() {
      var rgb = this.getRGB();
      return "rgb(".concat(rgb.r.toFixed(0), ", ").concat(rgb.g.toFixed(0), ", ").concat(rgb.b.toFixed(0), ")");
    }
  }, {
    key: "toRGBA",
    value: function toRGBA() {
      var rgb = this.getRGB();
      var a = (this.a / 100).toFixed(2);
      return "rgba(".concat(rgb.r.toFixed(0), ", ").concat(rgb.g.toFixed(0), ", ").concat(rgb.b.toFixed(0), ", ").concat(a, ")");
    }
  }, {
    key: "toHSL",
    value: function toHSL() {
      var hsl = this.getHSL();
      return "hsl(".concat(hsl.h.toFixed(0), ", ").concat(hsl.s.toFixed(0), "%, ").concat(hsl.l.toFixed(0), "%)");
    }
  }, {
    key: "toHSLA",
    value: function toHSLA() {
      var hsl = this.getHSL();
      var a = (this.a / 100).toFixed(2);
      return "hsla(".concat(hsl.h.toFixed(0), ", ").concat(hsl.s.toFixed(0), "%, ").concat(hsl.l.toFixed(0), "%, ").concat(a, ")");
    }
  }, {
    key: "toString",
    value: function toString() {
      var format = this.format,
          hasAlpha = this.hasAlpha;

      if (format === 'hex') {
        return hasAlpha ? this.toHex8() : this.toHex();
      }

      if (format === 'rgb') {
        if (hasAlpha) {
          return this.toRGBA();
        }

        return this.toRGB();
      }

      if (hasAlpha) {
        return this.toHSLA();
      }

      return this.toHSL();
    }
  }], [{
    key: "fromEmpty",
    value: function fromEmpty(options) {
      return new Color({
        h: 0,
        s: 100,
        l: 50,
        a: 100
      }, options);
    }
  }, {
    key: "fromString",
    value: function fromString(str, options) {
      var color = string2RGB(str);

      if (color == null) {
        return Color.fromEmpty(options);
      }

      return new Color(_objectSpread({
        a: color.a
      }, RGB2HSL(color)), options);
    }
  }, {
    key: "fromRGB",
    value: function fromRGB(rgb, options) {
      return new Color(_objectSpread({
        a: 1
      }, RGB2HSL(rgb)), options);
    }
  }, {
    key: "fromRGBA",
    value: function fromRGBA(rgba, options) {
      return new Color(_objectSpread({
        a: rgba.a
      }, RGB2HSL(rgba)), options);
    }
  }, {
    key: "fromHSL",
    value: function fromHSL(hsl, options) {
      return new Color(_objectSpread({
        a: 1
      }, hsl), options);
    }
  }, {
    key: "fromHSLA",
    value: function fromHSLA(hsla, options) {
      return new Color(hsla, options);
    }
  }]);

  return Color;
}();